import React from 'react';
import FaqContainer from '../../../Containers/UserContainer/Faq';
const FaqScreen = () => {
  return <FaqContainer />;
};

export default FaqScreen;
